var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",attrs:{"for":_vm.id}},[_c('input',{attrs:{"id":_vm.id,"type":"checkbox","aria-label":_vm.id},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }